
const newModel = () => {
    return {
        truongMamnonHocsinhId: null,
        truongMamnonId: null,
        tenTruongMamnon: null,
        idKy: null,
        tenKy: null,
        tongsoHocsinh: "0",
        hocsinhNu: "0",
        hocsinhDantocThieuso: "0",
        hocsinhKhuyettat: "0",
        hocsinhSuydinhduong: "0",
        hocsinh3den12M: "0",
        hocsinh13den24M: "0",
        hocsinh25den36M: "0",
        hocsinh3den4Y: "0",
        hocsinh4den5Y: "0",
        hocsinh5den6Y: "0",
        tongsoHocsinhDadinhdanh: "0",
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongMamnonHocsinhId: null,
        truongMamnonId: null,
        idKy: null,
        tongsoHocsinh: "0",
        hocsinhNu: "0",
        hocsinhDantocThieuso: "0",
        hocsinhKhuyettat: "0",
        hocsinhSuydinhduong: "0",
        hocsinh3den12M: "0",
        hocsinh13den24M: "0",
        hocsinh25den36M: "0",
        hocsinh3den4Y: "0",
        hocsinh4den5Y: "0",
        hocsinh5den6Y: "0",
        tongsoHocsinhDadinhdanh: "0",
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        truongMamnonHocsinhId: item.truongMamnonHocsinhId,
        truongMamnonId: item.truongMamnonId,
        tenTruongMamnon: item.tenTruongMamnon,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoHocsinh: item.tongsoHocsinh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinhSuydinhduong: item.hocsinhSuydinhduong,
        hocsinh3den12M: item.hocsinh3den12M,
        hocsinh13den24M: item.hocsinh13den24M,
        hocsinh25den36M: item.hocsinh25den36M,
        hocsinh3den4Y: item.hocsinh3den4Y,
        hocsinh4den5Y: item.hocsinh4den5Y,
        hocsinh5den6Y: item.hocsinh5den6Y,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongMamnonHocsinhId: item.truongMamnonHocsinhId,
        truongMamnonId: item.truongMamnonId,
        tenTruongMamnon: item.tenTruongMamnon,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoHocsinh: item.tongsoHocsinh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinhSuydinhduong: item.hocsinhSuydinhduong,
        hocsinh3den12M: item.hocsinh3den12M,
        hocsinh13den24M: item.hocsinh13den24M,
        hocsinh25den36M: item.hocsinh25den36M,
        hocsinh3den4Y: item.hocsinh3den4Y,
        hocsinh4den5Y: item.hocsinh4den5Y,
        hocsinh5den6Y: item.hocsinh5den6Y,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
} 

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongMamnonId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongMamnonId: item.truongMamnonId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongMamnonHocsinhId: null,
        truongMamnonId: null,
        idKy: null,
        tongsoHocsinh: null,
        hocsinhNu: null,
        hocsinhDantocThieuso: null,
        hocsinhKhuyettat: null,
        hocsinhSuydinhduong: null,
        hocsinh3den12M: null,
        hocsinh13den24M: null,
        hocsinh25den36M: null,
        hocsinh3den4Y: null,
        hocsinh4den5Y: null,
        hocsinh5den6Y: null,
        tongsoHocsinhDadinhdanh: null,
        ghiChu: null,
        enabled: null,
    }
}

export const truongMamnonHocsinhModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


